import { addRoutes, delRoutes, editRoutes, getMenuList, getPlatformList } from '@/services/menu/MenuController';
import * as AntdIcons from '@ant-design/icons';
import { ProFormInstance } from '@ant-design/pro-components';
import { useRequest } from 'ahooks';
import { message } from 'antd';
import { debounce } from 'lodash-es';
import { useEffect, useRef, useState } from 'react';

export default function AuthModel() {
  const formRef = useRef<ProFormInstance>();
  const [operation, setOperation] = useState<'look' | 'edit' | 'addSubset' | 'delete'>('look');

  const [loading, setLoading] = useState(true);
  // 菜单详情
  const [menuItem, setMenuItem] = useState<object>({});
  /** 展开树的键值 */
  const [expandedKeys, setExpandedKeys] = useState<string[]>([]);
  //  判读是否可以编辑表单
  const [disabled, setDisabled] = useState(true);

  // 平台类型列表
  const [options, setOptions] = useState([]);
  // 平台类型id
  const [platformId, setPlatformId] = useState<null | number>(null);

  const [menuList, setMenuList] = useState([]);
  // 动态图标
  const LazyLoadIcon = (iconName: string) => {
    // @ts-ignore
    return AntdIcons[iconName];
    // TODO 目前在windows 无法运行mako . 所以暂时无法使用动态引入
    // return React.lazy(() =>
    //   import(`@ant-design/icons/es/icons/${iconName}`).catch(() => {
    //     return { default: () => <span>not</span> };
    //   }),
    // );
  };

  /**
   * 获取所有keys,用于展开所有树
   * @param data
   */
  const getAllKeys = (data: any[] = []): string[] => {
    return data.reduce((keys: string[], item) => {
      keys.push(item.id); // 使用 `id` 作为 key
      if (item.children) {
        keys.push(...getAllKeys(item.children)); // 使用扩展运算符代替 concat
      }
      return keys;
    }, []);
  };
  /** 获取菜单列表 **/
  const getMenuListReq = useRequest(getMenuList, {
    manual: true,
    onBefore: () => {
      setLoading(true);
    },
    onSuccess: (data) => {
      setLoading(false);
      setMenuList(data);
    },
  });

  /** 获取平台列表**/
  const getPlatformListReq = useRequest(getPlatformList, {
    manual: true,
    onSuccess: (data) => {
      // console.log('success', data[0].platform_id);
      const option = data.map((item: any) => ({ value: item.platform_id, label: item.platform_name }));
      setOptions(option);
    },
  });
  /** 新增菜单 */
  const setRoutesReq = useRequest(addRoutes, {
    manual: true,
    onBefore: () => {
      setLoading(true);
      setDisabled(true);
    },
    onError: () => {
      setDisabled(false);
    },
    onSuccess: () => {
      getMenuListReq.refresh();
      setLoading(false);
      setDisabled(true);
      message.success('新增成功');
    },
  });

  //编辑菜单
  const editRoutesReq = useRequest(editRoutes, {
    manual: true,
    onBefore: () => {
      setLoading(true);
    },
    onError: () => {
      setDisabled(false);
      setLoading(false);
    },
    onSuccess: () => {
      setDisabled(true);
      setLoading(false);
      getMenuListReq.refresh();
      message.success('编辑成功');
    },
  });
  //删除菜单
  const delRoutesReq = useRequest(delRoutes, {
    manual: true,
    onBefore: () => {
      setLoading(true);
    },
    onError: () => {
      setLoading(false);
    },
    onSuccess: () => {
      getMenuListReq.refresh();
      setLoading(false);
      message.success('删除成功');
    },
  });

  /**
   *  需要监听Loading状态的方法
   *  仅 useRequest 返回的函数可以录入
   */
  const effectLoadingList = [getMenuListReq, getPlatformListReq, setRoutesReq, editRoutesReq, delRoutesReq];

  useEffect(() => {
    // 防抖处理的函数，延迟500ms后执行setLoading
    const debouncedSetLoading = debounce((loading: boolean) => {
      setLoading(loading);
    }, 0);
    const bool = effectLoadingList.some((item) => {
      return item.loading;
    });
    debouncedSetLoading(bool);
    // 清理防抖函数
    return () => {
      debouncedSetLoading.cancel();
    };
  }, [getMenuListReq, getPlatformListReq, setRoutesReq, editRoutesReq, delRoutesReq]);

  return {
    getPlatformListReq,
    getMenuListReq,
    getAllKeys,
    expandedKeys,
    setExpandedKeys,
    loading,
    setLoading,
    platformId,
    setPlatformId,
    disabled,
    setDisabled,
    LazyLoadIcon,
    options,
    setOptions,
    menuList,
    setRoutesReq,
    editRoutesReq,
    delRoutesReq,
    menuItem,
    setMenuItem,
    formRef,
    operation,
    setOperation,
  };
}
